<template>
  <div id="search-projects">
    <input
      ref="searchInput"
      v-model="draft"
      type="text"
      placeholder="Rechercher dans les titres"
      aria-label="Rechercher dans les titres"
      :class="{ 'has-clear': draft }"
      @input="searchProjects"
    />
    <button
      v-if="draft"
      type="button"
      class="clear-search"
      aria-label="Effacer la recherche"
      @mousedown.prevent
      @click.stop="clearSearch"
    >
      <svg viewBox="0 0 12 12" aria-hidden="true">
        <path d="M2.2 2.2l7.6 7.6M9.8 2.2L2.2 9.8" />
      </svg>
    </button>
    <i class="search icon" aria-hidden="true" />
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "SearchProjects",

  data() {
    return {
      draft: "",
    };
  },

  computed: {
    ...mapState("projects", ["searchProjectsFilter"]),
  },

  watch: {
    searchProjectsFilter(value) {
      if (document.activeElement !== this.$refs.searchInput) {
        this.draft = value || "";
      }
    },
  },

  created() {
    this.draft = this.searchProjectsFilter || "";
    this.debouncedSearch = debounce((text) => this.runSearch(text), 100);
  },

  beforeDestroy() {
    this.debouncedSearch.cancel();
  },

  methods: {
    ...mapMutations("projects", ["SET_CURRENT_PAGE"]),
    ...mapActions("projects", ["SEARCH_PROJECTS"]),

    searchProjects(e) {
      this.debouncedSearch(e.target.value);
    },

    clearSearch() {
      this.debouncedSearch.cancel();
      this.draft = "";
      this.runSearch("");
      this.$refs.searchInput.focus();
    },

    runSearch(text) {
      this.$emit("loading", true);
      this.SET_CURRENT_PAGE(1);
      this.SEARCH_PROJECTS({ text })
        .then(() => {
          this.$emit("loading", false);
        })
        .catch((err) => {
          if (err.message) {
            this.$emit("loading", false);
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
#search-projects {
  position: relative;
  width: 100%;
  font-size: 0.95rem;

  .search.icon {
    position: absolute;
    right: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    color: #3a468e;
    font-size: 1.15rem;
    width: 1.15rem;
    height: 1.15rem;
    margin: 0;
    z-index: 1;
    pointer-events: none;
  }

  .clear-search {
    position: absolute;
    top: 1px;
    right: 2.15rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.75rem;
    height: 100%;
    border: 0;
    border-radius: 4px;
    background: transparent;
    color: #3a468e;
    padding: 0;
    cursor: pointer;
    z-index: 2;

    svg {
      display: block;
      width: 12px;
      height: 12px;
      stroke: currentColor;
      stroke-width: 1.6;
      stroke-linecap: round;
      fill: none;
    }
  }

  input {
    display: block;
    width: 100%;
    height: 2.75rem;
    text-align: left;
    color: #1f2a37;
    padding: 0.6rem 2.4rem 0.6rem 0.85rem;
    border: 1px solid #3a468e;
    border-radius: 6px;
    background: #fff;
    font-size: 0.92rem;
    font-family: var(
      --font-family,
      "Roboto Condensed",
      "Lato",
      "Helvetica Neue",
      Arial,
      Helvetica,
      sans-serif
    );

    &.has-clear {
      padding-right: 5.2rem;
    }

    &::placeholder {
      color: #9aa3af;
    }

    &:focus {
      outline: none;
      border-color: #3a468e;
      box-shadow: 0 0 0 1px rgba(58, 70, 142, 0.25);
    }
  }
}
</style>
